import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { auth_actions, global_actions } from "../../../../redux-store";
import { Notification } from "../../../../utils";
import backend from "../../../../api";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";

const ChangeCredentials = () => {
  const { handleSubmit, register, errors, getValues, setValue } = useForm();
  const { user } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [paymentinfo, setPaymentinfo] = useState(
    user && user.paypal_account ? "paypal_account" : "bank_routing"
  );
  const [customerId, setCustomerId] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  console.log("user", user);

  useEffect(() => {
    if (user) {
      if (user?.user?.role === "customer") {
        setPhone(user.user.phone);
      } else if (user?.user?.role === "merchant" || user?.user?.role === "member") {
        setPhone(user.user.phone);
      }
      setFirstName(user.user.first_name);
      setMiddleName(user.user.middle_name);
      setLastName(user.user.last_name);
      setEmail(user.user.email);
      if (user?.user?.role === "customer") {
        backend
          .get("/customer", { params: { _id: user._id } })
          .then(({ data }) => {
            setCustomerId(data.data[0]._id);
          })
          .catch((error) => {});
      }
    }
  }, [user]);

  const submitForm = () => {
    setIsSubmitting(true);
    let { email, ...values } = getValues();
    console.log("values",values)
    let role;
    if (values) {
      if (user?.user?.role === "customer" && customerId !== "") {
        role = "customer";
        let customer = {
          ...values,
          address: {
            name: values.name,
            state: values.state,
            zip: values.zip,
            country: values.country,
            city: values.city,
            operation: "edit",
            _id: user.addresses[0]._id,
          },
          customerId: customerId,
          userId: user.user._id,
        };
        dispatch(auth_actions.updateCustomer(customer));
        history.push("/dashboard/customer");
      } else if (user?.user?.role === "member") {
        role = "member";
        let member = {
          ...values,
          id: user.user._id,
        };
        dispatch(auth_actions.updateCredentials(member));
        history.push("/dashboard/member/account");
      } else if (user?.user?.role === "merchant") {
        role = "merchant";
        let merchant = {
          ...values,
          company_address: values.company_address,
          [["paypal_account", "bank_routing"].filter(
            (i) => i !== paymentinfo
          )[0]]: undefined,
          id: user.user._id,
        };
        dispatch(auth_actions.updateCredentialsByRole(merchant, role));
        history.push("/dashboard/merchant");
      } else if (user?.user?.role === "brand") {
        role = "brand";
        let brand = {
          ...values,
          [["paypal_account", "bank_routing"].filter(
            (i) => i !== paymentinfo
          )[0]]: undefined,
          company_address: values.company_address,
          id: user.user._id,
        };
        dispatch(auth_actions.updateCredentialsByRole(brand, role));
      }
    }
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (user) {
      dispatch(global_actions.loading(true));
      const status = new Notification();
      backend
        .get("/country")
        .then(({ data }) => {
          setCountries(data.data);
        })
        .catch((error) => {
          status.set_toast(
            "error",
            error.response ? error.response.data.message : error.message
          );
        })
        .finally(() => {
          dispatch(global_actions.loading(false));
          status.show_toast();
        });
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      setValue("first_name", firstName);
      setValue("middle_name", middleName);
      setValue("last_name", lastName);
      setValue("email", email);
      setValue("phone", phone);
    }
  }, [firstName, middleName, lastName, email, phone, user, setValue]);

  return (
    <div>
      <Helmet>
        <title>eksplode! | Change Credentials</title>
      </Helmet>
      {user ? (
        <div className="dashboard">
          <div className="box-account box-info">
            <div className="box-head">
              <h3>Account Details</h3>
            </div>
            <div className="row mt-3">
              <div className="col-lg-12 mx-auto register-page section-b-space">
                <div className="theme-card">
                  <form className="theme-form">
                    <div className="form-row">
                      <div className="col-md-4">
                        <label htmlFor="fname">First Name</label>
                        <input
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          type="text"
                          className="form-control"
                          id="fname"
                          name="first_name"
                          placeholder="First Name"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="fname" className="error">
                          {errors.first_name && errors.first_name.message}
                        </label>
                      </div>
                      {user && user?.user?.role !== "merchant" && (
                        <div className="col-md-4">
                          <label htmlFor="mname">Middle Name</label>
                          <input
                            value={middleName}
                            onChange={(e) => setMiddleName(e.target.value)}
                            type="text"
                            className="form-control"
                            id="mname"
                            name="middle_name"
                            placeholder="Middle Name"
                            ref={register({
                              required: {
                                value:
                                  user?.user?.role === "merchant"
                                    ? false
                                    : true,
                                message: "This Field is Required",
                              },
                            })}
                          />
                          <label htmlFor="mname" className="error">
                            {errors.middle_name && errors.middle_name.message}
                          </label>
                        </div>
                      )}
                      <div className="col-md-4">
                        <label htmlFor="lname">Last Name</label>
                        <input
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          type="text"
                          className="form-control"
                          id="lname"
                          name="last_name"
                          placeholder="Last Name"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="lname" className="error">
                          {errors.last_name && errors.last_name.message}
                        </label>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-4">
                        <label htmlFor="email">Email</label>
                        <input
                          value={email}
                          type="text"
                          className="form-control"
                          id="email"
                          name="email"
                          disabled
                          placeholder="Email"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                            pattern: {
                              value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                              message: "This must be a valid Email",
                            },
                          })}
                        />
                        <label htmlFor="email" className="error">
                          {errors.email && errors.email.message}
                        </label>
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="cell">Phone Number:</label>
                        <input
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          type="number"
                          className="form-control"
                          id="cell"
                          placeholder="Enter your number"
                          name="phone"
                          ref={register({
                            required: {
                              value: true,
                              message: "This Field is Required",
                            },
                          })}
                        />
                        <label htmlFor="cell" className="error">
                          {errors.number && errors.number.message}
                        </label>
                      </div>
                    </div>

                    {user && user.role === "customer" && (
                      <>
                        <div className="form-row">
                          <div className="col-md-6">
                            <label htmlFor="name">Street Address</label>
                            <input
                              defaultValue={user.addresses[0].name}
                              type="text"
                              name="name"
                              className="form-control"
                              placeholder="Street Address"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This field is required",
                                },
                              })}
                            />
                            <label htmlFor="name" className="error">
                              {errors.name && errors.name.message}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="country">Country</label>
                            <select
                              className="form-control"
                              id="country"
                              type="text"
                              name="country"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "Please Select a Country",
                                },
                              })}
                              onChange={(e) =>
                                e.target.value &&
                                setCities(
                                  countries.find(
                                    (cn) => cn._id === e.target.value
                                  ).cities
                                )
                              }
                            >
                              <option selected value="">
                                Select Country
                              </option>
                              {countries.map((cn) => (
                                <option value={cn._id} key={cn._id}>
                                  {cn.country_name}
                                </option>
                              ))}
                            </select>

                            <label htmlFor="country" className="error">
                              {errors.country && errors.country.message}
                            </label>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6">
                            <label htmlFor="city">City</label>
                            <select
                              className="form-control"
                              id="city"
                              type="text"
                              name="city"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "Please Select a City",
                                },
                              })}
                            >
                              <option selected value="">
                                {Boolean(cities.length)
                                  ? "Select City"
                                  : "Select Country first"}{" "}
                              </option>
                              {cities.map((cn) => (
                                <option value={cn._id} key={cn._id}>
                                  {cn.city_name}
                                </option>
                              ))}
                            </select>

                            <label htmlFor="city" className="error">
                              {errors.city && errors.city.message}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="state">State</label>
                            <input
                              defaultValue={user.addresses[0].state}
                              className="form-control"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This field is required",
                                },
                              })}
                              type="text"
                              id="state"
                              name="state"
                              placeholder="State"
                            />
                            <label htmlFor="state" className="error">
                              {errors.state && errors.state.message}
                            </label>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6">
                            <label htmlFor="zip">Zip</label>
                            <input
                              defaultValue={user.addresses[0].zip}
                              className="form-control"
                              type="text"
                              id="zip"
                              name="zip"
                              placeholder="Zip"
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This field is required",
                                },
                                pattern: {
                                  value: /^[\d]+$/,
                                  message: "This field must be a number",
                                },
                              })}
                            />
                            <label htmlFor="zip" className="error">
                              {errors.zip && errors.zip.message}
                            </label>
                          </div>
                        </div>
                      </>
                    )}
                    {user && ["brand", "merchant"].some((i) => i == user.role) && (
                      <>
                        <div className="form-row">
                          <div className="col-md-6">
                            <label htmlFor="state">Company Address </label>
                            <input
                              className="form-control"
                              defaultValue={user.company_address}
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This field is required",
                                },
                              })}
                              type="text"
                              id="company_address"
                              name="company_address"
                              placeholder="Company Address"
                            />
                            <label htmlFor="company_address" className="error">
                              {errors.company_address &&
                                errors.company_address.message}
                            </label>
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="col-md-6">
                            <label htmlFor="broute">Receive Payments Via</label>
                            <div className="d-flex justify-content-start mt-3">
                              <input
                                type="radio"
                                className="form-control w-auto mx-5"
                                id="broute"
                                name="paypal_broute"
                                value="paypal_account"
                                checked={paymentinfo === "paypal_account"}
                                onChange={(e) => setPaymentinfo(e.target.value)}
                              />
                              <p>Paypal Account</p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <input
                                type="radio"
                                className="form-control w-auto mx-5"
                                id="broute"
                                name="paypal_broute"
                                value="bank_routing"
                                checked={paymentinfo === "bank_routing"}
                                onChange={(e) => setPaymentinfo(e.target.value)}
                              />
                              <p>Bank's Routing Number</p>
                            </div>
                          </div>
                          {paymentinfo === "paypal_account" && (
                            <div className="col-md-6">
                              <label htmlFor="paypinfo">Paypal Email</label>
                              <input
                                defaultValue={user.paypal_account}
                                type="text"
                                className="form-control"
                                id="paypinfo"
                                name="paypal_account"
                                placeholder="Paypal Email"
                                ref={register({
                                  required: {
                                    value: true,
                                    message: "This Field is Required",
                                  },
                                  pattern: {
                                    value: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a.z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
                                    message: "This must be a valid Email",
                                  },
                                })}
                              />
                              <label htmlFor="paypinfo" className="error">
                                {errors.paypal_account &&
                                  errors.paypal_account.message}
                              </label>
                            </div>
                          )}
                          {paymentinfo === "bank_routing" && (
                            <div className="col-md-6">
                              <label htmlFor="brouting">
                                Bank's Routing No.
                              </label>
                              <input
                                type="number"
                                defaultValue={parseInt(user.bank_routing)}
                                className="form-control"
                                id="brouting"
                                name="bank_routing"
                                placeholder="Bank's Routing Number"
                                ref={register({
                                  required: {
                                    value: true,
                                    message: "This Field is Required",
                                  },
                                })}
                              />
                              <label htmlFor="brouting" className="error">
                                {errors.bank_routing &&
                                  errors.bank_routing.message}
                              </label>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                    {user && user.role === "member" && (
                      <>
                        <div className="box-head">
                          <h3>Security questions:</h3>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="question">
                                Enter the first name of your best friend:
                              </label>
                              <input
                                defaultValue={user.user.member_bestfriend}
                                type="text"
                                className="form-control mb-0"
                                id="question"
                                name="member_bestfriend"
                                placeholder="Answer here"
                                ref={register({
                                  required: {
                                    value: true,
                                    message: "This Field is Required",
                                  },
                                })}
                              />
                              <label htmlFor="question" className="error">
                                {errors.member_bestfriend &&
                                  errors.member_bestfriend.message}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="question">Favorite color:</label>
                              <input
                                defaultValue={user.user.member_favorite_color}
                                type="text"
                                className="form-control mb-0"
                                id="question"
                                name="member_favorite_color"
                                placeholder="Answer here"
                                ref={register({
                                  required: {
                                    value: true,
                                    message: "This Field is Required",
                                  },
                                })}
                              />
                              <label htmlFor="question" className="error">
                                {errors.member_favorite_color &&
                                  errors.member_favorite_color.message}
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="form-row">
                    <button
                        className="btn btn-solid"
                        onClick={handleSubmit(submitForm)}
                        disabled={isSubmitting} 
                      >
                        {isSubmitting ? "Updating..." : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default ChangeCredentials;
